import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
export var getResponsiveValueAtIndex = function(responsiveValues, index, defaultValue) {
    var _responsiveValues_tabletAndAbove, _responsiveValues_desktopAndAbove;
    var _responsiveValues_mobileAndAbove_index;
    return {
        mobileAndAbove: (_responsiveValues_mobileAndAbove_index = responsiveValues.mobileAndAbove[index]) !== null && _responsiveValues_mobileAndAbove_index !== void 0 ? _responsiveValues_mobileAndAbove_index : defaultValue,
        tabletAndAbove: (_responsiveValues_tabletAndAbove = responsiveValues.tabletAndAbove) === null || _responsiveValues_tabletAndAbove === void 0 ? void 0 : _responsiveValues_tabletAndAbove[index],
        desktopAndAbove: (_responsiveValues_desktopAndAbove = responsiveValues.desktopAndAbove) === null || _responsiveValues_desktopAndAbove === void 0 ? void 0 : _responsiveValues_desktopAndAbove[index]
    };
};
export var convertServerResponsivePropertyToClientResponsiveProperty = function(defaultValue, convertServerToClientValue, serverResponsiveValues) {
    var _serverResponsiveValues_mobile_and_above;
    var values = {
        mobileAndAbove: convertServerToClientValue((_serverResponsiveValues_mobile_and_above = serverResponsiveValues === null || serverResponsiveValues === void 0 ? void 0 : serverResponsiveValues.mobile_and_above) !== null && _serverResponsiveValues_mobile_and_above !== void 0 ? _serverResponsiveValues_mobile_and_above : defaultValue)
    };
    var tabletAndAbove = (serverResponsiveValues === null || serverResponsiveValues === void 0 ? void 0 : serverResponsiveValues.tablet_and_above) ? convertServerToClientValue(serverResponsiveValues === null || serverResponsiveValues === void 0 ? void 0 : serverResponsiveValues.tablet_and_above) : undefined;
    var desktopAndAbove = (serverResponsiveValues === null || serverResponsiveValues === void 0 ? void 0 : serverResponsiveValues.desktop_and_above) ? convertServerToClientValue(serverResponsiveValues === null || serverResponsiveValues === void 0 ? void 0 : serverResponsiveValues.desktop_and_above) : undefined;
    var xLargeAndAbove = (serverResponsiveValues === null || serverResponsiveValues === void 0 ? void 0 : serverResponsiveValues.x_large_and_above) ? convertServerToClientValue(serverResponsiveValues === null || serverResponsiveValues === void 0 ? void 0 : serverResponsiveValues.x_large_and_above) : undefined;
    if (tabletAndAbove) {
        Object.assign(values, {
            tabletAndAbove: tabletAndAbove
        });
    }
    if (desktopAndAbove) {
        Object.assign(values, {
            desktopAndAbove: desktopAndAbove
        });
    }
    if (xLargeAndAbove) {
        Object.assign(values, {
            xLargeAndAbove: xLargeAndAbove
        });
    }
    return values;
};
export var getResponsiveStylingClassNames = function(responsiveValues, responsiveClassNamesMap) {
    return Object.entries(responsiveValues).filter(function(param) {
        var _param = _sliced_to_array(param, 2), _ = _param[0], value = _param[1];
        return value !== undefined;
    }).map(function(param) {
        var _param = _sliced_to_array(param, 1), key = _param[0];
        return responsiveClassNamesMap[key];
    }).filter(isNotUndefined);
};
/**
 * Given a set of responsive values for certain viewports and a mapping of
 * those viewports to a desired style classname and variable name,
 * return all valid classnames and their associated style variables.
 *
 * E.g. if mobileAndAbove's value should be in var1 and should be applied to class1,
 * the input should be `{mobileAndAbove: value1}, {"mobileAndAbove": ["class1", "var1"]}`
 *
 * Optionally, provide a function to transform it into a desired CSS value.
 *
 * E.g. if value1 is 12 but we want 12px, getStyleForVarName should be `(value: number) => value + "px"`
 */ export var getResponsiveStyles = function(responsiveValues, classNamesAndVars) {
    var getStyleForVarName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(value) {
        return "".concat(value);
    };
    var computedClassNames = Object.entries(responsiveValues).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        var _classNamesAndVars_key;
        return value ? (_classNamesAndVars_key = classNamesAndVars[key]) === null || _classNamesAndVars_key === void 0 ? void 0 : _classNamesAndVars_key[0] : undefined;
    }).filter(isNotUndefined);
    var computedStyleVars = Object.entries(responsiveValues).reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        var _classNamesAndVars_key;
        var _ref = _sliced_to_array((_classNamesAndVars_key = classNamesAndVars[key]) !== null && _classNamesAndVars_key !== void 0 ? _classNamesAndVars_key : [], 2), varName = _ref[1];
        if (!value || !varName) {
            return acc;
        }
        return _object_spread_props(_object_spread({}, acc), _define_property({}, varName, getStyleForVarName(value)));
    }, {});
    return {
        className: classNames(computedClassNames),
        style: assignInlineVars(computedStyleVars)
    };
};
